import { useContext, useEffect } from 'react';
import { HomeScrollContext } from '../context/HomeScrollContext';
import { useIsTabFocused } from './useIsTabFocused';

/**
 * 탭 컨텐츠에서 자신의 scrollToTop 동작을 Home 에 등록.
 * 포커스된 동안에만 등록되며 unfocus / unmount 시 자동 해제.
 *
 * @example
 * useRegisterScrollToTop('TODAY', () => {
 *   listRef.current?.scrollToOffset({ offset: 0, animated: true });
 * });
 */
export const useRegisterScrollToTop = (
  screenName: string,
  scrollToTop: () => void,
) => {
  const focused = useIsTabFocused(screenName);
  const homeScroll = useContext(HomeScrollContext);

  useEffect(() => {
    if (!focused || !homeScroll) return;
    homeScroll.registerScrollToTop(scrollToTop);
    return () => homeScroll.registerScrollToTop(null);
  }, [focused, homeScroll, scrollToTop]);
};
